var GenericView = require('views/generic.view.ts');
var Handlebars = require('handlebars');
var Template = require('text-loader!../../templates/results/maximizes_self-sufficiency.results.template.html');
var Handlebars = require('../../../libs/handlebars/handlebars-v4.0.5.js');

var TheView = GenericView.extend({
    el: '#selfSufficiency',
    tagName: '',
	template: Handlebars.compile(Template),
	data: null,
	initialize: function (options) {
        this.data = options.data;
        this.render();
    },
    superRender: GenericView.prototype.render,
    render: function () {
        var self = this;
        this.superRender();
        this.$el.html(this.template(this.data));

        var years = [];
        $.each( self.data.cashFlows.cashFlowsIn, function( index, value ) {
          years.push(index+1);
        });

        GenericView.prototype.createBarChart('selfSufficiency-monthly_scr', 'Monthly SCR (%)', '', '', this.data.tableSCR, [], ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"], '', '', '#4472c4', '', false);
        GenericView.prototype.createBarChart('selfSufficiency-monthly_ssr', 'Monthly SSR (%)', '', '', this.data.tableSSR, [], ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"], '', '', '#4472c4', '', false);
        GenericView.prototype.createBarChart('selfSufficiency-cash_flow', 'Cash flow per year (€)', '', '', this.data.cashFlows.cashFlowsIn, this.data.cashFlows.cashFlowsOut, years, 'CashInFlows', 'CashOutFlows', '#4472c4', '#ed7d31', true);

    },
    events: {

    },
});

module.exports= TheView;